import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const generateValue = (value: string) => {
  return value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
};

/** RFC 4122 UUID format (e.g. 8-4-4-4-12 hex). Use to avoid API calls with route segments like "dashboard". */
const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Returns true only when orgId is a valid GUID. Use before any API call that takes orgId
 * so that route segments like "dashboard" are never sent as orgId.
 */
export function isValidOrgId(
  orgId: string | null | undefined,
): orgId is string {
  return typeof orgId === "string" && GUID_REGEX.test(orgId);
}
